import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardText,
  Row,
  CardFooter,
} from "reactstrap";

const Pricing = () => {
  const contentCards = [
    {
      type: "Monthly",
      price: 29.99,
    },
    {
      type: "Yearly",
      price: 300,
    },
  ];

  function Carousel() {
    return (
      <>
        <Row
          className="d-flex justify-content-center align-items-center mx-0 custom-pricing-padding"
          style={{ gap: "1rem" }}
        >
          {contentCards?.map((item, index) => {
            return (
              <Card
                key={index}
                className="carosel_card"
                style={{
                  width: "22rem",
                }}
              >
                <CardHeader className="d-flex justify-content-center mb-0 my_plans_title py-3 text-capitalize">
                  {item.type} Plan
                </CardHeader>
                <CardBody>
                  <Row className="justify-content-center align-items-baseline pricing-card-title">
                    <span className="my_plans_price">${item.price}</span>
                    <span className="my_plans_month">/{item.type}</span>
                  </Row>
                  <CardText className="d-flex justify-content-start py-2 text-muted">
                    ✔️ 14 Days Free Trial
                  </CardText>
                </CardBody>
                <CardFooter className="border-0 ">
                  <Button type="button" color="danger" className="subscribe">
                    Subscribe
                  </Button>
                </CardFooter>
              </Card>
            );
          })}
        </Row>
      </>
    );
  }
  return (
    <div className="py-4 py-md-6 pricing" id="pricing">
      <h1 className="mb-4 text-center">Pricing</h1>
      <Carousel className="mt-2" />
    </div>
  );
};

export default Pricing;
